// filepath: frontend/src/store/authStore.ts
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { User } from '@/types';

interface AuthState {
  user: User | null;
  accessToken: string | null;
  isAuthenticated: boolean;
  viewingOrgId: string | null;
  setUser: (user: User) => void;
  setAccessToken: (token: string) => void;
  setViewingOrg: (orgId: string | null) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      isAuthenticated: false,
      viewingOrgId: null,
      setUser: (user) => set({ user, isAuthenticated: true }),
      setAccessToken: (accessToken) => set({ accessToken }),
      setViewingOrg: (viewingOrgId) => set({ viewingOrgId }),
      logout: () => set({ user: null, accessToken: null, isAuthenticated: false, viewingOrgId: null }),
    }),
    {
      name: 'potopod_auth',
      partialize: (state) => ({
        user: state.user,
        isAuthenticated: state.isAuthenticated,
        // Do NOT persist accessToken — refresh from httpOnly cookie on reload
      }),
    }
  )
);
